import {DataGrid, esES} from "@mui/x-data-grid";
import React, {useEffect, useState} from "react";
import {fileFormatter} from "../../utils/formatters/fileFormatter";
import {Box, Checkbox, Skeleton} from "@mui/material";
import {useForm} from "react-hook-form";
import {FileBase, FileBaseFields, SolicitationFileViewDTO} from "../../types/solicitation/solicitationFile";
import {HttpClientFile} from "../../http/client/httpClientFile";
import {LoaderBlockUI} from "../loader";
import {useAction} from "../../hooks/useAction";

interface LibraryFilesSelectFormProps {
    onSubmitFile?: (fileBase?: FileBase, file?: File, fileId?: number) => Promise<number>,
    clientId: number,
    onClose: () => void,
    onReload?: () => void
}

const LibraryFilesSelectForm = ({onSubmitFile, clientId, onClose, onReload}: LibraryFilesSelectFormProps) => {
    const [pageSize, setPageSize] = useState<number>(50)
    const [selectedFiles, setSelectedFiles] = useState<number[]>([])
    const [files, setFiles] = useState<SolicitationFileViewDTO[]>()
    const [loading, setLoading] = useState<boolean>(false)
    const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false)
    const {snackbarSuccess, snackbarError} = useAction()

    useEffect(() => {
        setLoading(true)
        HttpClientFile.getSolicitationsFiles(clientId).then((r) => {
            setFiles(r)
        }).finally(() => setLoading(false))
    }, [clientId])
    
    const {handleSubmit} = useForm()
    
    const onSubmit = (data: any) => {
        console.log(data)
        if (onSubmitFile) {
            setLoadingSubmit(true)
            const submittedFiles = selectedFiles.map((id) => 
                onSubmitFile(undefined, undefined, id)
            )
            Promise.all(submittedFiles).then(() => {
                snackbarSuccess('Los archivos se adjuntaron correctamente')
                onClose()
                onReload && onReload()
            })
                .catch(() => snackbarError('Ocurrió un error al adjuntar los archivos'))
                .finally(() => setLoadingSubmit(false))
        }
    }

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let newSelectedFiles
        if (event.target.checked) {
            newSelectedFiles = [...selectedFiles, parseInt(event.target.value)]
            setSelectedFiles(newSelectedFiles)
        } else {
            newSelectedFiles = selectedFiles.filter(id => id !== parseInt(event.target.value))
            setSelectedFiles(newSelectedFiles)
        }
    }

    const cols = [
        {
            flex: 0.05,
            field: 'icon',
            minWidth: 80,
            headerName: '',
            renderCell: (params: any) => (
                fileFormatter.getIconByFileName(params.row[FileBaseFields.FileDesc], {fontSize: 'large'})
            ),
            id: 1
        },
        {
            flex: 0.5,
            minWidth: 170,
            field: 'descArchivo',
            headerName: 'Archivo',
            id: 2
        },
        {
            flex: 0.3,
            minWidth: 170,
            field: 'descArchivoTipo',
            headerName: 'Tipo',
            id: 3
        },
        {
            flex: 0.05,
            minWidth: 100,
            field: 'actions',
            headerName: '',
            renderCell: (params: any) => (
                <Checkbox
                    value={params.row.id}
                    onChange={(e) =>
                        handleCheckboxChange(e)
                    }
                />
            ),
            id: 4
        },
    ]
    
    return (
        <form id={'file-from-library-form'} onSubmit={handleSubmit(onSubmit)}>
            {
                loading && Array.from({length: 6}).map((d, idx) => <Box key={idx} sx={{width: '100%'}}><Skeleton/></Box>)
            }
            {
                !loading && files &&
                <DataGrid columns={cols}
                          rows={files}
                          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                          autoHeight
                          rowsPerPageOptions={[50, 100]}
                          pageSize={pageSize}
                          onPageSizeChange={newPageSize => setPageSize(newPageSize)}
                />
            }
            {loadingSubmit && <LoaderBlockUI />}
        </form>
    )
}


export default LibraryFilesSelectForm